import { useEffect, useState } from "react";
import { getAudit } from "../lib/api";
import type { AppConfig } from "../types";

interface Props { config: AppConfig; }

export function ActionLog({ config }: Props) {
  const [items, setItems] = useState<any[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function carregar() {
    setBusy(true); setErr(null);
    try {
      const r = await getAudit(config);
      setItems(r.items);
    } catch (e: any) {
      setErr(e.message);
    } finally { setBusy(false); }
  }
  useEffect(() => { carregar(); }, [config]);

  return (
    <div className="log">
      <div className="log-head">
        <h2>Auditoria — últimas {items.length} ações</h2>
        <button onClick={carregar} disabled={busy}>↻ atualizar</button>
      </div>
      {err && <div className="error">⚠ {err}</div>}
      <table>
        <thead>
          <tr>
            <th>Quando</th>
            <th>Tool</th>
            <th>Status</th>
            <th>Tempo</th>
            <th>Args / Detalhe</th>
          </tr>
        </thead>
        <tbody>
          {items.map((l) => (
            <tr key={l.id} className={l.ok ? "ok" : "fail"}>
              <td>{new Date(l.ts).toLocaleString("pt-BR")}</td>
              <td><code>{l.tool}</code></td>
              <td>{l.ok ? "OK" : "FALHOU"}</td>
              <td>{l.duration_ms}ms</td>
              <td className="detail">
                <details>
                  <summary>{(l.detail || "").slice(0, 80)}</summary>
                  <pre>args: {JSON.stringify(l.args, null, 2)}</pre>
                  <pre>detail: {l.detail}</pre>
                </details>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
